import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IRoomServiceRequest } from "@/@types/room-service/room-service";

interface IRoomServiceState {
  knownIds: string[];
  newCount: number;
  emergencyCount: number;
  activeRequests: IRoomServiceRequest[];
  initialized: boolean;
}

const state: IRoomServiceState = {
  knownIds: [],
  newCount: 0,
  emergencyCount: 0,
  activeRequests: [],
  initialized: false,
};

const mutations: MutationTree<IRoomServiceState> = {
  SET_KNOWN_IDS(state, ids: string[]) {
    state.knownIds = ids;
  },
  SET_NEW_COUNT(state, count: number) {
    state.newCount = count;
  },
  SET_EMERGENCY_COUNT(state, count: number) {
    state.emergencyCount = count;
  },
  SET_ACTIVE_REQUESTS(state, list: IRoomServiceRequest[]) {
    state.activeRequests = list;
  },
  SET_INITIALIZED(state, value: boolean) {
    state.initialized = value;
  },
  RESET_ROOM_SERVICE(state) {
    state.knownIds = [];
    state.newCount = 0;
    state.emergencyCount = 0;
    state.activeRequests = [];
    state.initialized = false;
  },
};

const actions: ActionTree<IRoomServiceState, IRootState> = {
  setRoomServiceKnownIds({ commit }, ids: string[]) {
    commit("SET_KNOWN_IDS", ids);
  },
  setRoomServiceNewCount({ commit }, count: number) {
    commit("SET_NEW_COUNT", count);
  },
  setRoomServiceEmergencyCount({ commit }, count: number) {
    commit("SET_EMERGENCY_COUNT", count);
  },
  setRoomServiceActiveRequests({ commit }, list: IRoomServiceRequest[]) {
    commit("SET_ACTIVE_REQUESTS", list);
  },
  setRoomServiceInitialized({ commit }, value: boolean) {
    commit("SET_INITIALIZED", value);
  },
  resetRoomService({ commit }) {
    commit("RESET_ROOM_SERVICE");
  },
};

const getters: GetterTree<IRoomServiceState, IRootState> = {
  getRoomServiceNewCount(state) {
    return state.newCount;
  },
  getRoomServiceEmergencyCount(state) {
    return state.emergencyCount;
  },
  getRoomServiceActiveRequests(state) {
    return state.activeRequests;
  },
  getRoomServiceKnownIds(state) {
    return state.knownIds;
  },
  getRoomServiceInitialized(state) {
    return state.initialized;
  },
};

export const roomServiceModul: Module<IRoomServiceState, IRootState> = {
  state,
  mutations,
  actions,
  getters,
};
